<template>
  <div class="w-full h-full">
    <client-only>
      <div
        v-if="title"
        id="clickEvent"
        class="flex items-center justify-between h-full"
        @click="isOpen = !isOpen"
      >
        <span class="w-full" :class="titleClass">
          {{ title }}
        </span>
        <ArrowDown
          class="w-5 h-5 ml-2 transition-all duration-100 text-opacity-30"
          :class="[isOpen ? 'rotate-180' : '', titleClass]"
        />
      </div>
      <div
        v-if="isOpen"
        class="fixed inset-x-0 top-auto right-auto flex items-center justify-center w-full border-none md:w-auto bottom-28 md:bottom-auto md:mr-5 md:block md:left-auto md:absolute md:top-0 md:right-full"
      >
        <div v-click-away="() => (isOpen = false)">
          <DatePicker
            :value="null"
            v-model.range="date"
            :attributes="attrs"
            :expanded="expanded"
            :key="updateKey"
            @dayclick="updateDateEvent"
            @dayfocusout="updateDateEvent"
            @weeknumberclick="updateDateEvent"
            @update:modelValue="updateModelValue"
          />
        </div>
      </div>
    </client-only>
  </div>
</template>

<script setup>
import { useScreens } from "vue-screen-utils";
import { DatePicker } from "v-calendar";
import ArrowDown from "@/assets/svg/heroicons/arrow-down.svg?component";

const props = defineProps({
  titleClass: {
    type: String,
    default: "text-secondary-light",
  },
  title: {
    type: String,
    default: null,
  },
  defaultOpen: {
    type: Boolean,
    default: false,
  },
  defaultDate: {
    type: Object,
    default: {
      start: "",
      end: "",
    },
  },
});

const emit = defineEmits();
const { mapCurrent } = useScreens({
  xs: "0px",
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
});

const isOpen = ref(props.defaultOpen);
const updateKey = ref(0);
const expanded = mapCurrent({ default: false, lg: true }, true);
const attrs = ref([
  {
    key: "today",
    highlight: {
      color: "blue",
      fillMode: "solid",
    },
    dates: new Date(),
  },
  {
    highlight: {
      start: { fillMode: "solid", color: "blue" },
      base: { fillMode: "light", color: "blue" },
      end: { fillMode: "solid", color: "blue" },
    },
  },
]);

const date = ref(props.defaultDate);

watch(
  isOpen,
  (newValue, oldValue) => {
    emit("has-open", newValue);
    updateKey.value++;
    date.value = props.defaultDate;
  },
  { deep: true }
);

onBeforeUnmount(() => {
  isOpen.value = false;
});

const updateDateEvent = (_, event) => {
  event.target.blur();
};
const updateModelValue = (e) => {
  emit("update-date", e);
};
</script>
<style>
@import "v-calendar/style.css";

@media only screen and (max-width: 725px) {
  .vc-container {
    margin: 20px !important;
    border: none !important;
    box-shadow: 0 0 10px #ddd !important;
  }
}
.vc-container .vc-blue {
  --vc-accent-600: #f1d4b5 !important;
  --vc-highlight-outline-bg: #f1d4b5 !important;
  --vc-accent-200: rgb(252, 248, 237, 1) !important;
  --vc-accent-900: #0a0908 !important;
  --currentColor: #f1d4b5 !important;
  --vc-highlight-outline-content-color: #ffffff !important;
}
/* .vc-arrows-container {
  padding-left: 25px !important;
  padding-right: 35px !important;
} */
.vc-svg-icon path {
  fill: #f1d4b5 !important;
}
.vc-container.vc-expanded {
  border: none !important;
  box-shadow: 0 0 10px #ddd !important;
}
/* .vc-weeks {
  width: 320px !important;
  padding-left: 25px !important;
} */
.vc-container.vc-expanded {
  min-width: 300px !important;
}
.vc-day {
  min-height: 40px !important;
}
.vc-monthly .is-not-in-month * {
  @apply opacity-10;
}
.vc-day-content:hover {
  color: white !important;
  background-color: #f2d4b6 !important;
}
.vc-day-content {
  @apply font-OPPO-sans-regular text-base w-10 h-10;
}
.vc-highlights .vc-day-box-center-center .vc-highlight {
  border: none !important;
}
.vc-day-content:focus {
  color: white !important;
  background: #f1d4b5 !important;
}
.vc-highlight,
.vc-weekday {
  @apply w-10 h-10 leading-none;
}
.vc-weekday {
  @apply w-auto pt-5 !important;
}
.vc-day.in-next-month span {
  opacity: 0.5 !important;
}
</style>
